// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".styles-module__LockBanner__2W7W5{position:fixed;bottom:0;left:0;right:0;height:var(--case-lock-banner-height, 48px);background:#1a1a18;display:flex;align-items:center;justify-content:center;gap:10px;z-index:100;box-shadow:0 -1px 0 rgba(255,255,255,.06),0 -4px 16px rgba(0,0,0,.18)}.styles-module__LockBannerIcon__IfTWZ{display:flex;align-items:center;justify-content:center;width:20px;height:20px;flex-shrink:0;color:#a0a09a}.styles-module__LockBannerIcon__IfTWZ svg{width:16px;height:16px}.styles-module__LockBannerText__2x0oy{font-size:13px;font-weight:500;color:#e8e8e4;letter-spacing:.01em}", ""]);
// Exports
exports.locals = {
	"LockBanner": "styles-module__LockBanner__2W7W5",
	"LockBannerIcon": "styles-module__LockBannerIcon__IfTWZ",
	"LockBannerText": "styles-module__LockBannerText__2x0oy"
};
export default exports;
